import classes from "./Clem.module.scss";
import Banner from "./Banner/Banner";
import GetInTouch from "../../Components/GetInTouch/GetInTouch";
import ClemStrategy from "./ClemStrategy/ClemStrategy";
import ClemMethod from "./ClemMethod/ClemMethod";
import ClemEcosystem from "./ClemEcosystem/ClemEcosystem";
import ClemVision from "./ClemVision/ClemVision";
import GlobalPresence from "../LandingPage/GlobalPresence/GlobalPresence";

function Clem() {
  return (
    <div className={classes.container}>
      <Banner />
      <GlobalPresence />
      <ClemVision />
      <ClemEcosystem />
      <ClemStrategy />
      <ClemMethod
        id="clem-transition"
        method="Transition"
        title={
          <>
            Our <span>Strategy</span> and <span>Solution</span>
          </>
        }
        imgUrl="https://se-website-image.s3.ap-south-1.amazonaws.com/clem/clem-transition.png"
        content={[
          "Provides a detailed transition plan to facilitate the shift from fossil fuels to clean energy, ensuring profitability while generating additional cash flows.",
          "Identified bankable investment opportunities and supports portfolio decarbonization.",
        ]}
      />
      <ClemMethod
        id="clem-enablement"
        method="Enablement"
        title={
          <>
            Our Approach - <span>Feasibility</span>
          </>
        }
        imgUrl="https://se-website-image.s3.ap-south-1.amazonaws.com/clem/clem-enablement.png"
        content={[
          "Ensures clean energy projects are financially viable, bankable, and attractive to investors.",
          "Enables financials institutions to identify bankable projects and decarbonize their portfolios.",
        ]}
      />
      <GetInTouch />
    </div>
  );
}

export default Clem;
